<template>
  <div class="filling-area">

  {{boxOt}}
    <div class="d-flex">
      <div style="border-radius: 10px 10px 0 0" class="filling-content wd-100p">
        <div
          ref="scrlbr"
          v-if="rdy"
          :style="
            `height: ${
              prms.questionShuffle != undefined && prms.questionShuffle
                ? 'auto'
                : scrollHeight + 'px'
            } !important; overflow: auto; position: relative;`
          "
          class="filling-scroll"
        >
          <div class="mg-x-20 pd-b-20" v-if="mode == 0 && confirmObj.modal">
            <div class="card mg-t-20">
              <div class="text-left card-body bd">
                <h6 class="bd-l bd-5 bd-gray-500 pd-l-5">Шалгалтын нэр:</h6>
                <p class="mg-b-0">{{ prms.nm }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card">
                  <div class="card-body bd">
                    <div class="media">
                      <div class="mg-r-20">
                        <feather type="circle"></feather>
                      </div>
                      <div class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Асуултын тоо
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          {{ prms.qCount }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card">
                  <div class="card-body bd">
                    <div class="media">
                      <div class="mg-r-20">
                        <feather type="clock"></feather>
                      </div>
                      <div class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Үргэлжлэх хугацаа
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          {{ getDuration(prms, "hours") }}
                          <sup class="mg-l-5">цаг</sup>
                          {{ getDuration(prms, "minutes") }}
                          <sup class="mg-l-5">минут</sup>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card">
                  <div class="card-body bd">
                    <div class="media">
                      <div class="mg-r-20">
                        <feather type="flag"></feather>
                      </div>
                      <div v-if="prms.hasPayment" class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Оролдлогын төлбөр
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          <span v-show="prms.attemptCount > 0"
                            >{{ prms.resultCount }}/{{
                              prms.attemptCount
                            }}</span
                          >
                          {{ prms.budget | formatMoney(0, ".", ",") }} ₮
                        </h6>
                      </div>
                      <div v-else class="media-body">
                        <h6
                          class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                        >
                          Боломжит оролдлого
                        </h6>
                        <h6 class="tx-13 tx-normal mg-b-0">
                          {{ prms.resultCount }}/{{ prms.attemptCount }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="alert alert-warning" role="alert">
              <!-- {{ prms }} -->
              Та хичээлийн шалгалт эхлүүлэх гэж байна. Итгэлтэй байна уу?
            </div>

            <div class="text-center d-flex">
              <button
                v-if="prms.resultCount > 0"
                @click="showLessonExamResult()"
                class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
              >
                Өмнөх үр дүн харах ({{ prms.resultCount }})
              </button>
              <div class="btn-group mg-l-auto">
                <!-- <button
              @click="confirmObj.modal=false"
              class="btn btn-sm pd-x-15 btn-secondary btn-uppercase"
            >Үгүй</button> -->
                <button
                  v-if="!prms.hasPayment"
                  @click="startLessonExam()"
                  class="btn btn-sm pd-x-15 btn-success btn-uppercase"
                >
                  Эхлэх
                </button>
                <button
                  v-if="prms.hasPayment && prms.payedInvoice"
                  @click="startLessonExam()"
                  class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
                >
                  Оролдлогыг эхлүүлэх
                </button>
                <button
                  v-if="
                    prms.hasPayment &&
                      !prms.payedInvoice &&
                      prms.resultCount >= prms.attemptCount
                  "
                  @click="checkPaymentAndGoExam()"
                  class="btn btn-sm pd-x-15 btn-warning btn-uppercase"
                >
                  Төлбөр төлөх
                </button>
                <button
                  v-if="prms.hasPayment && prms.resultCount < prms.attemptCount"
                  @click="startLessonExam()"
                  class="btn btn-sm pd-x-15 btn-success btn-uppercase"
                >
                  Эхлэх
                </button>
              </div>
            </div>
          </div>

          <div v-else-if="mode == 2" class="card card-widget card-events">
            <!-- <div class="d-flex pd-10">
            <div>
              
            </div>
            <button class=" mg-l-auto btn btn-info btn-xs">Оролдлого +</button>
          </div> -->

            <div class="pd-20">
              <apexchart
                type="line"
                height="350"
                :options="chartOptions"
                :series="series"
                :key="chartOptionsKey"
              ></apexchart>

              <ul class="list-unstyled media-list mg-b-0 pd-x-5">
                <li
                  class="media "
                  v-for="(r, i) in lessonExamResults"
                  :key="i"
                  @click="showLessonExamFilled(r)"
                  role="button"
                >
                  <div class="media-left" style="min-width: 50px">
                    <label>{{ r.date | moment("dddd") }}</label>
                    <p>{{ r.date | moment("DD") }}</p>
                  </div>
                  <div class="media-body event-panel-green">
                    <span class="event-time"
                      >{{ r.date | moment("HH:mm") }} -
                      {{ r.finishedAt | moment("HH:mm") }}</span
                    >
                    <h6 class="event-title">
                      {{ r.perc.toFixed(2) }}% 
                        <template v-if="getExamDurationShow(r)">
                          (<span v-if="!$store.state.app.isMobile">
                            зарцуулсан хугацаа:
                          </span>
                          {{ getExamDuration(r) }}
                          <sup>минут</sup> )
                        </template>
                    </h6>
                  </div>
                  <div
                    class="flex-row mg-l-auto d-flex align-items-center justify-content-center pd-x-10"
                  >
                    <button
                      class="text-center link text-lowercase"
                      role="button"
                    >
                      <span v-if="!$store.state.app.isMobile">
                        Хэрхэн бөглөснийг
                        <br />харах
                      </span>
                      <span v-else> <feather type="eye"></feather></span>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-else-if="mode == 3" class="pd-10">
            <!-- ene mon uu -->
            <div v-for="(q, i) in form.questions" :key="i" class="mg-b-20">
              <div
                class="d-flex tx-16 align-items-center"
                :class="{
                  'text-success':
                    q.isFilled &&
                    q.as.filter((x) => x.aId == q.answerId && x.isTrue).length >
                      0,
                  'text-danger':
                    q.isFilled &&
                    q.as.filter((x) => x.aId == q.answerId && x.isTrue)
                      .length == 0,
                  'text-warning': !q.isFilled,
                }"
              >
                <div class="mg-r-10 text-muted">
                  <div class="rounded-circle bg-primary ht-50 wd-50">
                    {{ i + 1 }}
                  </div>
                </div>
                <div
                  v-if="q.t == 31"
                  v-html="generateMissingWordsFilled(q)"
                  class="pd-y-5"
                ></div>
                <div v-else v-html="q.q" class="font-weight-normal"></div>
              </div>
              <div v-if="q.t == 1 || q.t == 11"></div>
              <div v-else-if="q.t == 3" class="mg-x-30 mg-b-10">
                <div
                  v-for="(a, ai) in q.as"
                  :key="ai"
                  class="`mg-t-10`"
                  :class="{
                    'text-danger': q.answerId == a.aId && !a.isTrue,
                    'text-success': a.isTrue,
                    'text-warning': !q.isFilled && a.isTrue,
                  }"
                >
                  <div class="d-flex tx-14">
                    <div class="mg-r-10 tx-16">
                      <i
                        class="far"
                        :class="{
                          'fa-check-circle': a.isTrue,
                          'fa-times-circle': q.answerId == a.aId && !a.isTrue,
                          'fa-circle': q.answerId != a.aId && !a.isTrue,
                        }"
                      ></i>
                    </div>
                    <div class="mg-r-10">{{ alphabetize(ai) }}.</div>
                    <div v-html="a.a"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="mode == 4" class="pd-10">
            <div v-for="(q, i) in form.questions" :key="i" class="mg-b-20">
              <div class="d-flex tx-16">
                <div class="mg-r-10 tx-thin text-muted">{{ i + 1 }}.</div>
                <div v-if="q.t == 31" style="font-weight:500" class="pd-y-5">
                  <div v-html="generateMissingWords(q)"></div>
                </div>
                <div v-else v-html="q.q" style="font-weight:500"></div>
              </div>

              <div class="mg-x-30 mg-b-10">
                <div v-if="q.t == 31" class="alert alert-light tx-13 mg-y-10">
                  Цэгийн оронд тохирох үгийг сонгоно уу
                </div>
                <div
                  v-else-if="q.t == 32 || q.t == 33"
                  style="overflow: hidden; max-width: 100%"
                >
                  <div class="row">
                    <div :class="`col-${q.t == 33 ? '12' : '6'}`">
                      <ul class="list-group" v-if="q.t == 32">
                        <li
                          v-for="(a, i) in sortedAnswers(q)"
                          :key="i"
                          class="list-group-item d-flex align-items-center"
                        >
                          <div>{{ i + 1 }}.</div>
                          <div
                            v-if="a.if"
                            class="bg-gray-100 rounded mg-l-10 pd-y-5 pd-x-10 bd"
                          >
                            {{ a.a }}
                          </div>
                          <button
                            @click="submitExamQuestion(q, a, 0)"
                            class="btn btn-xs btn-icon btn-outline-light mg-l-auto"
                          >
                            <feather type="x"></feather>
                          </button>
                        </li>
                      </ul>
                      <div v-else-if="q.t == 33" class="pyramid">
                        <div
                          @click="submitExamQuestion(q, a, 0)"
                          class="zone"
                          v-for="(a, i) in sortedAnswers(q)"
                          :key="i"
                        >
                          <div v-if="a.if" class="pd-t-50">
                            <div
                              class="bg-white tx-color-02 pd-y-5 pd-x-10 bd pos-relative"
                            >
                              {{ a.a }}
                              <button
                                @click="submitExamQuestion(q, a, 0)"
                                class="btn btn-xs btn-icon btn-outline-light mg-l-auto"
                              >
                                <feather type="x"></feather>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :class="`col-${q.t == 33 ? '12' : '6'}`">
                      <ul class="list-group">
                        <li
                          v-for="(a, i) in q.as.filter((x) => !x.if)"
                          :key="i"
                          class="list-group-item d-flex align-items-center"
                        >
                          <button
                            @click="submitExamQuestion(q, a)"
                            class="btn btn-xs btn-icon btn-outline-light mg-r-10"
                          >
                            <feather
                              v-if="q.t == 32"
                              type="chevron-left"
                            ></feather>
                            <feather
                              v-else-if="q.t == 33"
                              type="chevron-up"
                            ></feather>
                          </button>
                          {{ a.a }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="q.t == 3"
                  @click="submitExamQuestion(q, a)"
                  v-for="(a, ai) in q.as"
                  :key="ai"
                  :class="`mg-t-10`"
                  role="button"
                >
                  <div class="d-flex tx-14">
                    <div class="mg-r-10 tx-16">
                      <i
                        :class="
                          `far fa-${
                            q.isFilled && a.aId == q.answerId
                              ? 'check-circle'
                              : 'circle'
                          }`
                        "
                      ></i>
                    </div>
                    <div class="mg-r-10">{{ alphabetize(ai) }}.</div>
                    <div v-html="a.a"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="pd-15">
            <div
              v-if="form.info != '' && form.info != '<p><br></p>'"
              v-html="form.info"
              class="bd-b mg-b-10"
            ></div>
            <div
              v-for="(q, i) in form.questions"
              :key="i"
              class="mg-b-20 pos-relative"
              :id="`qa_${q.id}`"
            >
              <div class="d-flex tx-16 tx-gray-600">
                <div class="mg-r-10 tx-thin text-muted">
                  {{ i + 1 }}. <span style="color:red" v-show="q.rq.ir">*</span>
                </div>
                <div v-if="q.t == 31" style="font-weight:500" class="pd-y-5">
                  <div v-html="generateMissingWords(q)"></div>
                </div>
                <div v-else v-html="q.s1" style="font-weight: 500"></div>

                <div
                  v-show="
                    q.t == 3 &&
                      !q.isFilled &&
                      q.a.filter((x) => x.isFilled).length
                  "
                  class="pos-absolute r-30 b-20"
                >
                  <button
                    v-show="!hideEndButton"
                    @click="submitExamQuestion(q, null, 1)"
                    class="btn btn-xs btn-uppercase btn-success "
                  >
                    <template v-if="q.isFilled">
                      <feather type="check"></feather>
                    </template>
                    <template v-else>
                      хадгалах
                    </template>
                  </button>
                </div>
              </div>
              <div
                class="bg-gray-100 mg-l-25 bd-l bd-5 pd-x-10 pd-y-5 mg-b-5 tx-color-03"
                v-if="q.s2 != null && q.s2 != ''"
              >
                {{ q.s2 }}
              </div>
              <div
                v-if="q.t == 3 || q.t == 4 || q.t == 23 || q.t == 24"
                class="mg-x-30 mg-b-10"
              >
                <div
                  v-if="
                    prms.questionShuffle != undefined && prms.questionShuffle
                  "
                  class="d-flex mg-t-10"
                >
                  <div
                    @click="
                      q.t == 3
                        ? submitExamQuestion(q, a, 0)
                        : submitQuestion(q, a)
                    "
                    role="button"
                    v-for="(a, ai) in q.a"
                    :key="ai"
                    :class="
                      `${getBg(q, a)} bd bd-1 rounded-${
                        q.t == 4 ? '20' : '10'
                      } mg-r-20 pd-x-17 pd-y-10`
                    "
                    style="padding-left: 17px; padding-right: 17px"
                  >
                    {{ a.s1 }}
                  </div>
                </div>
                <template v-else>
                  <div
                    v-for="(a, ai) in q.a"
                    :key="ai"
                    :class="`mg-t-10 ${getColor(q, a)}`"
                  >
                    <div
                      class="d-flex tx-14"
                      @click="
                        q.t == 3
                          ? submitExamQuestion(q, a, 0)
                          : submitQuestion(q, a)
                      "
                      role="button"
                    >
                      <div class="mg-r-10 tx-16">
                        <i
                          v-if="q.t == 4 || q.t == 23 || q.t == 24"
                          :class="
                            `far fa-${a.isFilled ? 'check-circle' : 'circle'}`
                          "
                        ></i>
                        <i
                          v-else-if="q.t == 3"
                          :class="
                            `far fa-${a.isFilled ? 'check-square' : 'square'}`
                          "
                        ></i>
                      </div>
                      <div v-if="form.flag != 700" class="mg-r-10">
                        {{ alphabetize(ai) }}.
                      </div>
                      <div v-html="a.s1"></div>
                    </div>
                    <div
                      v-show="q.t == 23 && a.isFilled == true"
                      class="pos-relative"
                    >
                      <Input
                        maxlength="4000"
                        v-model="a.str"
                        size="mini"
                        placeholder="Тайлбар бичнэ үү"
                        type="textarea"
                        :rows="3"
                      />
                      <button
                        v-show="!hideEndButton"
                        @click="submitQuestion(q, q.a[0], q.a[0].str, true)"
                        class="btn btn-xs btn-uppercase btn-success pos-absolute r-5 b-5"
                      >
                        <template v-if="a.isFilled">
                          <feather type="check"></feather>
                        </template>
                        <template v-else>
                          хадгалах
                        </template>
                      </button>
                    </div>
                    <div
                      class="bg-gray-100 mg-l-25 bd-l bd-5 pd-x-10 pd-y-5 tx-color-03"
                      v-if="a.i != null && a.i != ''"
                    >
                      {{ a.i }}
                    </div>
                  </div>
                </template>
              </div>
              <div
                v-else-if="q.t == 1 || q.t == 7 || q.t == 11"
                class="mg-x-30 mg-b-10 pos-relative"
              >
                <!-- {{ q }} -->
                <Input
                  v-model="q.a[0].s1"
                  :type="q.t == 11 ? 'textarea' : 'text'"
                  :rows="q.t == 11 ? 4 : 1"
                  placeholder="Энд бичнэ үү"
                  :disabled="hideEndButton"
                >
                  <template slot="prepend">
                    <button @click="submitQuestion(q, q.a[0], q.a[0].s1)">
                      <feather
                        v-if="q.isFilled"
                        style="color:#10b759"
                        type="check-square"
                      />
                      <feather v-else style="color:#dc3545" type="square" />
                    </button>
                  </template>
                </Input>
                <button
                  v-show="!hideEndButton"
                  @click="submitQuestion(q, q.a[0], q.a[0].s1)"
                  class="btn btn-xs btn-uppercase btn-success pos-absolute r-5 b-5"
                >
                  <template v-if="q.isFilled">
                    <feather type="check"></feather>
                  </template>
                  <template v-else>
                    хадгалах
                  </template>
                </button>
              </div>
              <div v-else-if="q.t == 21" class="mg-x-30 mg-b-10">
                <InputNumber v-model="q.a[0].s1"></InputNumber>
                <button
                  v-show="!hideEndButton"
                  @click="submitQuestion(q, q.a[0], q.a[0].s1)"
                  class="btn btn-xs btn-uppercase btn-success mg-l-5"
                >
                  <template v-if="q.isFilled">
                    <feather type="check"></feather>
                  </template>
                  <template v-else>
                    хадгалах
                  </template>
                </button>
              </div>
              <div v-else-if="q.t == 22" class="mg-x-30 mg-b-10">
                <DatePicker
                  type="date"
                  v-model="q.a[0].s1"
                  :format="'yyyy-MM-dd'"
                  :value-format="'yyyy-MM-dd'"
                ></DatePicker>
                <button
                  v-show="!hideEndButton"
                  @click="submitQuestion(q, q.a[0], q.a[0].s1)"
                  class="btn btn-xs btn-uppercase btn-success mg-l-5"
                >
                  <template v-if="q.isFilled">
                    <feather type="check"></feather>
                  </template>
                  <template v-else>
                    хадгалах
                  </template>
                </button>
              </div>
              <div
                v-else-if="q.t == 31"
                class="alert alert-light tx-13 mg-y-10 mg-x-30"
              >
                Цэгийн оронд тохирох үгийг сонгоно уу
              </div>
              <div v-else class="mg-x-30 mg-b-10">...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!hideFooter"
      class="bg-gray-100 d-flex pd-x-15 pd-y-10 bd-t"
      style="border-radius: 0 0 10px 10px;"
    >
      <div class="d-flex wd-100p align-items-center">
        <div>
          <button
            @click="reFill(0)"
            class="btn btn-light"
            v-if="boxOt == 117 && prms.qCount > 0"
          >
            <feather type="refresh-cw" class="mg-r-5"></feather>
            дахин бөглөх
          </button>
          <button
            v-show="!hideEndButton"
            @click="reFill(1)"
            v-if="(boxOt == 389 || boxOt == 503) && rdy"
            class="btn btn-light mg-l-auto"
          >
            Дуусгах
          </button>
          <button
            class="btn btn-light mg-l-auto"
            style="visibility: hidden;"
            v-show="hideEndButton"
          >
            .
          </button>
          <div v-if="mode == 4">
            <div
              id="countdown"
              class="text-center bg-gray-100 exam-timer tx-16 text-primary"
            ></div>
          </div>
        </div>
        <div class="btn-group mg-l-auto">
          <button
            v-if="mode == 4"
            @click="finishLessonExam(form.resultId)"
            class="btn pd-x-15 btn-light btn-uppercase"
          >
            Дуусгах
          </button>
          <button
            v-if="mode == 4"
            @click="rightSideBarChanged(true)"
            class="btn pd-x-15 btn-light btn-uppercase"
          >
            Явц
          </button>
          <button
            v-if="
              (prms.resultCount < prms.attemptCount && mode == 2) ||
                (prms.hasPayment && mode == 2)
            "
            v-on:click="refillLessonExam()"
            class="btn pd-x-15 btn-light btn-uppercase"
          >
            Дахин оролдох
          </button>

          <button
            v-if="mode == 3"
            v-on:click="
              form.questions = [];
              mode = 2;
            "
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
          >
            Үр дүнгүүд
          </button>
          <button
            v-if="!lessonDone"
            @click="$emit('on-lesson-finish')"
            :class="
              `btn mg-l-15 btn-xs pd-x-15 btn-outline-${
                $store.state.app.skin.dark ? 'white' : 'primary'
              } btn-icon btn-uppercase`
            "
            title="Хичээлийг дуусгах ?"
          >
            <feather
              type="check-square"
              size="16"
              title="Хичээлийг дуусгах ?"
            ></feather>
            Хичээлийг дуусгах ?
          </button>
        </div>
      </div>
    </div>

    <b-overlay :show="busy" no-wrap>
      <template #overlay>
        <div
          v-if="processing"
          class="p-4 text-center rounded bg-secondary text-light"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="p-3 text-center"
        >
          <p>
            <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
          </p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="busy = false"
              >Үгүй</b-button
            >
            <b-button
              variant="outline-success"
              @click="busyMode == 0 ? reFillDo() : finishSurvey()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>

    <b-sidebar v-model="mydataaa" right width="100vw">
      <div class="bg-white pd-5">
        <fill-sidebar
          :mode="mode"
          :form="form"
          :prms="prms"
          @finishLessonExam="
            finishLessonExam($event);
            rightSideBarChanged(false);
          "
          @showLessonExamResult="
            showLessonExamResult();
            rightSideBarChanged(false);
          "
          @refillLessonExam="
            refillLessonExam();
            rightSideBarChanged(false);
          "
        />
      </div>
    </b-sidebar>

    <b-modal
      v-model="filled.sidebar"
      hide-footer
      scrollable
      centered
      title="Бөглөсөн"
      modal-class="full-mdl"
    >
      <div class="mg-b-30">
        <div
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <img :src="`${myResBaseUrl}v4-assets/exam_passed.png`" />
          <h3>Та {{ filledResult.perc }}% авлаа</h3>
          <div class="text-muted mg-b-20" v-show="(prms.attemptCount - prms.resultCount)>0">
            Танд одоо {{ prms.attemptCount - prms.resultCount }} удаа шалгалт
            өгөх эрх байна
          </div>
          <div v-if="filledResult.canViewResult!==1 || ($store.state.app.activeGroup.id == 9241 ||
          $store.state.app.activeGroup.id == 9249)" style="" class="mg-b-30">
            <div
              style="width: 100%; display: grid; grid-template-columns: repeat(8, 1fr); grid-template-rows: repeat(auto-fill, auto-fill); grid-row-gap: .5em; grid-column-gap: 1em;"
            >
              <template v-for="ss in filledResult.form.sections">
                <div
                  v-for="(q, i) in filledResult.form.questions.filter(
                    (x) => x.sId == ss.id
                  )"
                  :key="i"
                  class="text-center bd rounded-20 d-flex align-items-center mg-x-10 mg-b-10 font-weight-bold"
                  style="flex-direction: column"
                >
                  <div class="rounded-circle bg-light pd-x-15 pd-y-10">
                    {{ (i + 1 < 10 ? "0" : "") + (i + 1) }}
                  </div>
                  <div class="pd-10">
                    <template v-if="q.isTrue">
                      <feather
                        type="check"
                        style="width: 20px; height: 20px; color: #10b759;"
                      ></feather>
                    </template>
                    <template v-else-if="!q.isFilled">
                      <feather
                        type="help-circle"
                        style="width: 20px; height: 20px; color: orange;"
                      ></feather>
                    </template>
                    <template v-else>
                      <feather
                        type="x"
                        style="width: 20px; height: 20px; color: #dc3545;"
                      ></feather>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="">
            <button
              @click="filled.sidebar = false"
              class="btn btn-white btn-lg"
            >
              Хаах
            </button>
            <button
              @click="
                filled.sidebar = false;
                refillLessonExam(true);
              "
              v-if="(prms.attemptCount - prms.resultCount) > 0"
              class="btn btn-primary btn-lg mg-l-20"
            >
              Шалгалт эхлүүлэх
            </button>
          </div>
        </div>
      </div>
      <div class="">
        <form-filled
          :id.sync="filled.formId"
          :userId="filled.userId"
          :mode="1"
          @hide-res="filled.sidebar = false"
          @on-result-loaded="resultLoaded"
          @on-result-loaded2024="resultLoaded2024"
        />
      </div>
    </b-modal>

    <b-modal
      v-model="tnxModal"
      hide-footer
      centered
      title="Баярлалаа"
      hide-header
      no-close-on-backdrop
    >
      <div class="mg-x-20">
        <div class="text-center pd-20">
          <feather
            type="smile"
            :size="64"
            class="mg-b-20 text-success"
          ></feather>
          <h5
            class="text-truncate tx-14-f"
            style="white-space: normal; max-height: 40px; min-height: 40px"
          >
            Та судалгааг бөглөж дуусгалаа. Танд баярлалаа
          </h5>
        </div>
        <div class="text-center">
          <div>
            <button
              @click="tnxModalHide()"
              class="btn btn-sm pd-x-15 btn-secondary btn-uppercase"
            >
              Хаах
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { localRead, getToken } from "@/libs/util";

import { romanize, alphabetize } from "@/libs/tools";
import { request } from "@/api/all";
import {
  Message,
  MessageBox,
  Notification,
  Input,
  InputNumber,
  DatePicker,
} from "element-ui";

var _ = require("lodash");
const moment = require("moment");
var downloadTimer;
import Cookies from "js-cookie";
import VueApexCharts from "vue-apexcharts";
import { mapActions } from "vuex";

import wordselect from "@/views/main/exam/wordselect.vue";
import Vue from "vue";
import Buttons from "../../../task/components/transfers/buttons.vue";

export default {
  components: {
    apexchart: VueApexCharts,
    vueCustomScrollbar,
    Input,
    InputNumber,
    DatePicker,
    MessageBox,
    Notification,
    fillSidebar: () => ({
      component: import("@/components/modules/form/fill/component/sidebar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    formFilled: () => ({
      component: import("@/components/modules/form/filled"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    Buttons,
  },
  props: {
    id: {
      type: Number,
      default: () => null,
    },
    boxId: {
      type: Number,
      default: () => null,
    },
    boxOt: {
      type: Number,
      default: () => null,
    },
    prms: {
      type: Object,
      default: () => {},
    },
    course: {
      type: Object,
      default: () => {},
    },
    rightSideBar: {
      type: Boolean,
      default: () => false,
    },
    lessonDone: {
      type: Boolean,
      default: () => false,
    },
    hideFooter: {
      type: Boolean,
      default: () => false,
    },
    fromModal: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      hideEndButton: false,
      missingWordSelectRendered: false,
      form: {
        questuins: [],
        sections: [],
        flat: null,
      },
      mode: 0,
      rdy: false,
      rdyMode: 0,

      processing: false,
      busy: false,
      busyMode: 0,
      processingObj: 0,
      processingMode: 0,

      confirmObj: {
        modal: false,
      },

      lessonExamResults: [],
      lessonExamResultActive: {
        id: null,
      },
      series: [
        {
          name: "%",
          data: [],
        },
      ],
      chartOptionsKey: 0,
      chartOptions: {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      tnxModal: false,
      mydataaa: false,

      filled: {
        userId: "",
        formId: null,
        sidebar: false,
      },
      _cid: null,
      _lid: null,
      scrollHeight: 0,
      filledResult: {
        form: [],
        sections: [],
        perc: null,
        canViewResult: null,
      },
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    this.$emit("form-page-rdy");
    request({
      api: { method: "POST", url: "Auth/RefreshToken" },
      store: this.$store,
    }).then((res) => {
      if (res != false) {
        Cookies.set("token", res.token, { expires: 1 });
        this.init(this.id);
      }
    });
    window.addEventListener("resize", this.getMainHeight);
    this.getMainHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMainHeight);
  },
  destroyed() {
    Object.assign(this.$data, this.$options.data());
    clearInterval(downloadTimer);
  },
  methods: {
    goToQ(e) {
      const container = this.$refs.scrlbr;
      const section = document.getElementById(`qa_${e}`);

      if (container && section) {
        //console.log("section", section, section.offsetTop, container);
        container.scrollTop = section.offsetTop;
      }
    },
    ...mapActions(["handleMainLayoutConfig"]),
    resultLoaded2024(e) {
      // console.log('resultLoaded2024', e);
      try{
        this.filledResult.perc = e.toFixed(2);
      }catch{
        
      }
      
    },
    resultLoaded(e) {
      // console.log('e', e);
      this.filledResult.form = e.form; 
      this.filledResult.perc = this.lessonExamResults
        .filter((x) => x.id == e.result.id)[0]
        ["perc"].toFixed(2);
      
      this.filledResult.canViewResult = e.result.canViewResult;
    },
    showLessonExamFilled(f) {
      this.filled.formId = f.id;
      this.filled.userId = this.$store.state.user.userId;
      this.filled.sidebar = true;
    },
    showLessonExamResult() {
      this.confirmObj.modal = false;

      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker",
      });
      request({
        api: { method: "GET", url: "V2/learn/GetLessonExamResult" },
        params: {
          examId: this.id,
          courseId: this.$route.params.cid,
          lessonId: this.$route.params.id,
          boxId: this.$route.params.bid,
          objectTypeId: this.$route.params.bot,
        },
        store: this.$store,
      }).then((res) => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker",
        });
        if (res != false) {
          this.lessonExamResults = res.data.results;

          this.series[0].data = res.data.results.map((x) => {
            return x.perc.toFixed(0);
          });
          this.chartOptions.xaxis.categories = res.data.results.map((x) => {
            return moment(x.date).format("MM.DD HH:mm");
          });
          this.chartOptionsKey++;

          this.mode = 2;
          this.rdy = true;
        }
      });
    },
    lessonExamStarted(m) {
      let _obj = this.$store.state.app.mainLayoutConfig;
      if (!m) {
        _obj.header = 2;
        _obj.expanded = false;
      } else {
        _obj.header = null;
        _obj.expanded = true;
      }

      this.handleMainLayoutConfig(_obj);
      this.$nextTick(() => {
        this.$emit("lesson-exam-started", m);
      });
    },

    createInvoice(budget, lessonInvBoxId) {
      let _submitModel = {};

      let _projid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 343
      );
      if (prj.length > 0) _projid = prj[0].id;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          projectId: _projid,
          parentId: 0,
          boxId: lessonInvBoxId,
          objectTypeId: 343,
          userId: this.$store.state.user.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          _submitModel = res.data.task;
          _submitModel.task = this.$store.state.user.userInfo.fullName;
          _submitModel.taskDesc = "Явцын шалгалтын төлбөр";
          _submitModel.budget = budget;
          //_submitModel.boxId= this.$route.params.boxId;
          _submitModel.defaultFormId = this.prms.id;
          _submitModel.thirdOrganizationTaskId = this.$route.params.id;
          _submitModel.fourthOrganizationTaskId = this.$route.params.cid;
          //console.log('Task/GetInherited=> ', res);

          _submitModel.phone = `/exam/${this.$route.params.cid}/${this.prms.id}/${this.$route.params.id}/${this.$route.params.bid}/${this.$route.params.bot}`;

          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "Task/PostInherited" },
            data: { model: _submitModel },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log('nehemjleh vvsleeeeeeeeeeeeeeeeeeeeee=> ', _submitModel.boxId, res.taskId);
              this.$router.push(`/lms/paymentDetail/${res.taskId}`);
            }
          });
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    checkPaymentAndGoExam(){
      this.toggleBodyClass("addClass", "dynamic-locker");      
        request({
          api: { method: "GET", url: "learn/getExamPreInfo" },
          params: {
            id: this.prms.id,
            boxId: this.$route.params.bid,
            lessonId: this.$route.params.id,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            
            // if (res.data.secure) {
            //   this.modalSecure = true;
            // } else 
            if (res.data.hasPayment) {
              if (res.data.invoiceId != null && res.data.invoiceId != undefined)
                this.$router.push(`/lms/paymentDetail/${res.data.invoiceId}`);
              else this.createInvoice(res.data.budget, res.data.invoiceBoxId);
            } else {
              //this.init();
              this.goToExamV5();
            }
          }
        });   
    },
    startLessonAfter() {
      if (this.prms.isRegisterRequired) {
        this.checkPaymentAndGoExam();     
      } else {
        window.examBackDisabled = true;
        this.$emit("on-toggle-class", {
          mode: "addClass",
          class: "dynamic-locker",
        });
        request({
          api: { method: "GET", url: "servertime" },
          store: this.$store,
        }).then((res) => {
          this.$emit("on-toggle-class", {
            mode: "removeClass",
            class: "dynamic-locker",
          });
          if (res != false) {
            if (moment(res.data.now).isBefore(this.$props.course.date.end)) {
              this.$router.push({
                name: "examOnline",
                params: {
                  courseId: this.$route.params.cid,
                  formId: this.id,
                  lessonId: this.$route.params.id,
                  boxId: this.$route.params.bid,
                  boxOt: this.$route.params.bot,
                },
              });
            } else {
              Notification.warning({
                message: "Үргэлжлэх хугацаа дууссан байна",
                duration: 3000,
                type: "warning",
                position: "top-right",
                offset: 50,
              });
            }
          }
        });
      }
    },
    goToExamV5() {
      let _url = "";
      //alert(this.$store.state.app.activeGroup.v5ExamBaseUrl);
      if (this.$store.state.app.activeGroup.v5ExamBaseUrl != undefined) {
        _url = `${this.$store.state.app.activeGroup.v5ExamBaseUrl}/#/login/${
          this.prms.id
        }/${this.$route.params.id}/${this.$route.params.bid}/${getToken()}`;
        window.location.replace(_url);
      }
    },
    startLessonExam() {
      MessageBox.confirm(
        "Та хичээлийн шалгалт эхлүүлэх гэж байна. Итгэлтэй байна уу?",
        "Мэдэгдэл",
        {
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          callback: (action) => {
            if (action == "cancel") {
            } else if (action == "confirm") {
              //this.toggleBodyClass("addClass", "dynamic-locker");

              this.startLessonAfter();
            }
          },
        }
      );
    },
    dispHM(m) {
      let rv = "";
      rv =
        '<span class="tmrdigit">' +
        Math.floor(m / 60) +
        '</span> <span>мин</span> <span class="tmrdigit">' +
        (Math.floor(m % 60) > 0
          ? Math.floor(m % 60) + "</span> <span>cек</span>"
          : "");
      return rv;
    },
    forceInterval() {
      Object.assign(this.$data, this.$options.data());
      clearInterval(downloadTimer);
    },
    init(id) {
      // console.log('init', this.boxOt);
      if (this.boxOt == 416) {
        clearInterval(downloadTimer);
        if (this.prms.resultCount > 0) {
          if (
            this.prms.resultCount == this.prms.attemptCount &&
            !this.prms.hasPayment
          ) {
            this.confirmObj.modal = false;
            this.showLessonExamResult();
          } else {
            this.$emit("on-toggle-class", {
              mode: "addClass",
              class: "dynamic-locker",
            });
            request({
              api: { method: "GET", url: "learn/HasNotFinishedLessonExams" },
              params: {
                formId: id,
                courseId: this.$route.params.cid,
                lessonId: this.$route.params.id,
                boxId: this.$route.params.bid,
                objectTypeId: this.$route.params.bot,
              },
              store: this.$store,
            }).then((res) => {
              this.$emit("on-toggle-class", {
                mode: "removeClass",
                class: "dynamic-locker",
              });
              if (res != false) {
                if (res.data.hasNotFinishedLessonExams) {
                  this.startLessonAfter();
                } else {
                  this.confirmObj.modal = true;
                  this.rdy = true;
                }
              }
            });
          }
        } else {
          this.confirmObj.modal = true;
          this.rdy = true;
        }
      } else {
        this.rdy = false;
        this.$emit("on-toggle-class", {
          mode: "addClass",
          class: "dynamic-locker",
        });
        let _cid = null;
        let _lid = null;
        if (
          this.$route.params.cid != undefined &&
          this.$route.params.cid != null
        ) {
          _cid = this.$route.params.cid;
        } else if (
          this.$route.params.id != undefined &&
          this.$route.params.id != null
        ) {
          _cid = this.$route.params.id;
        }

        if (
          this.$route.params.id != undefined &&
          this.$route.params.id != null &&
          this.$route.params.cid != undefined &&
          this.$route.params.cid != null
        ) {
          _lid = this.$route.params.id;
        }
        this._lid = _lid;
        if (
          this.$route.params.bid == undefined ||
          this.$route.params.bid == null ||
          this.$route.params.bid == 0
        ) {
          _lid = null;
          this._lid = null;
        }
        this._cid = _cid;
        let rprms= {
          form: id, courseId: _cid, lessonId: _lid
        };
        if(this.boxOt == 503){
          rprms = {
            form: id, 
            courseId: _cid
          };
        }
        // console.log('rprms', rprms);

        request({
          api: { method: "GET", url: "Form/GetLatestResponse" },
          params: rprms,
          store: this.$store,
        }).then((res) => {
          this.$emit("on-toggle-class", {
            mode: "removeClass",
            class: "dynamic-locker",
          });
          if (res != false) {
            this.form = res.data;
            this.$emit("on-fetch-sidebar", {
              form: this.form,
              mode: this.mode,
              prms: this.prms,
              rdy: true,
            });
            if (!this.missingWordSelectRendered) {
              this.$nextTick(() => {
                this.missingWordSelectRendered = true;
                this.form.questions
                  .filter((x) => x.t == 31)
                  .forEach((q) => {
                    for (let k = 1; k <= q.agc; k++) {
                      let optns = q.a
                        .filter((x) => x.g == k)
                        .map((answr) => {
                          return {
                            aId: answr.id,
                            a: answr.s1,
                            isFilled: answr.isFilled,
                          };
                        });
                      this.createMissingWordSelect(q.id, k, optns);
                    }
                  });
              });
            }

            this.rdy = true;
          } else {
            this.$emit("activate-modal-close");
            this.hideEndButton = true;
            this.surveyOverView(id, _cid, this._lid);
          }
        });
      }
    },
    surveyOverView(id, cid, lid) {
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker",
      });
      request({
        api: { method: "GET", url: "Form/GetLatestFormCheckedData" },
        params: {
          form: id,
          courseId: cid,
          lessonId: lid,
        },
        store: this.$store,
      }).then((res) => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker",
        });
        if (res != false) {
          this.form = res.data;
          this.rdy = true;
        }
      });
    },
    romanize(v) {
      return romanize(v);
    },
    alphabetize(v) {
      return alphabetize(v);
    },
    submitQuestion(q, a, str, isForce) {
      let _data = {
        formId: this.id,
        questionId: q.id,
        answerId: a.id,
        str: str,
        courseId: this._cid,
        lessonId: this._lid,
      };

      if (q.t == 1 || q.t == 11) {
        if (str == "" || str == undefined || str == null) {
          return false;
        }
      }

      if (q.t == 1 || q.t == 7 || q.t == 11 || q.t == 21 || q.t == 22) {
        _data = {
          formId: this.id,
          questionId: q.id,
          str: str,
          courseId: this._cid,
          lessonId: this._lid,
        };
      } else if (
        (q.t == 3 || q.t == 4 || (q.t == 23 && isForce) || q.t == 24) &&
        a.isResponse &&
        a.isFilled
      ) {
        _data = {
          formId: this.id,
          questionId: q.id,
          answerId: a.id,
          str: str,
          courseId: this._cid,
          lessonId: this._lid,
        };
      }
      if (q.t == 1 || q.t == 7 || q.t == 11 || q.t == 21 || q.t == 22) {
        request({
          api: { method: "POST", url: "Form/CheckQuestionPost" },
          data: _data,
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            Message("Амжилттай");
            q.isFilled = str != undefined && str != "";
            a.isFilled = str != undefined && str != "";
            this.$emit("on-form-filled", {
              id: this.id,
              boxId: this.boxId,
              fillingCount: this.form.questions.filter((x) => x.isFilled)
                .length,
            });
          }
        });
      } else if (q.t == 3 || q.t == 4 || (q.t == 23 && isForce) || q.t == 24) {
        request({
          api: { method: "POST", url: "Form/CheckQuestion" },
          params: _data,
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            if (q.t == 3 || q.t == 4 || q.t == 23 || q.t == 24) {
              if (q.t == 4 || q.t == 23) {
                q.a.forEach((e) => {
                  e.str = e.id == a.id ? e.str : "";
                  e.isFilled = e.id == a.id;
                });
              } else if (q.t == 3 || q.t == 24) {
                a.isFilled = !a.isFilled;
              } else {
                if (str == undefined) {
                  a.str = "";
                  a.isFilled = !a.isFilled;
                }
              }

              q.isFilled = q.a.filter((x) => x.isFilled).length > 0;
            } else {
              q.isFilled = str != undefined && str != "";
              a.isFilled = str != undefined && str != "";
            }

            this.$emit("on-form-filled", {
              id: this.id,
              boxId: this.boxId,
              fillingCount: this.form.questions.filter((x) => x.isFilled)
                .length,
            });
          }
        });
      } else if (q.t == 23 && !a.isFilled) {
        q.a.forEach((e) => {
          e.str = e.id == a.id ? e.str : "";
          e.isFilled = e.id == a.id;
        });
      }
    },
    getBg(q, a) {
      let rv;
      if (a != undefined) {
        if (a.isFilled) {
          rv = "bg-primary tx-white bd-primary";
        }
      }
      return rv;
    },
    getColor(q, a) {
      let rv;
      if (a != undefined) {
        if (
          this.prms.flag != undefined &&
          this.prms.flag == 700 &&
          q.isFilled &&
          a.isFilled
        ) {
          rv = "text-primary";
        } else {
          if (this.prms.flag != undefined && this.prms.flag == 800) {
            if (q.isFilled && a.isFilled && a.b1 == 100) {
              rv = "text-success";
            } else if (q.isFilled && a.isFilled && a.b1 != 100) {
              rv = "text-warning";
            } else if (q.isFilled && a.b1 == 100) {
              rv = "text-success";
            }
          }
        }
      } else {
        if (
          this.prms.flag != undefined &&
          this.prms.flag == 700 &&
          q.isFilled &&
          q.a.filter((x) => x.isFilled).length
        ) {
          rv = "text-primary";
        } else if (
          q.isFilled &&
          q.a.filter((x) => x.isFilled && x.b1 == 100).length
        ) {
          rv = "text-success";
        } else if (
          q.isFilled &&
          q.a.filter((x) => x.isFilled && x.b1 != 100).length
        ) {
          rv = "text-warning";
        } else if (
          (q.t == 1 || q.t == 7 || q.t == 11) &&
          q.isFilled &&
          q.a.filter((x) => x.s1 != null || x.s1 != "").length
        ) {
          rv = "text-primary";
        }
      }
      return rv;
    },
    reFill(m) {
      this.busyMode = m;
      this.busy = true;
    },
    reFillDo() {
      this.processing = true;
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker",
      });
      request({
        api: { method: "POST", url: "Form/TestRefill" },
        params: { id: this.id },
        store: this.$store,
      }).then((res) => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker",
        });
        this.processing = false;
        this.busy = false;
        if (res != false) {
          clearInterval(downloadTimer);
          this.init(this.id);
          this.$emit("on-reload");
        }
      });
    },
    finishSurvey() {
      this.processing = true;
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker",
      });
      request({
        api: { method: "POST", url: "Form/SurveyRefillByCourseIdLessonId" },
        data: { id: this.id, courseId: this._cid, lessonId: this._lid },
        store: this.$store,
      }).then((res) => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker",
        });
        this.processing = false;
        this.busy = false;
        if (res != false) {
          //alert("finish")
          this.$emit("on-finish-form");
          this.hideEndButton = true;

          this.processing = false;
          this.busy = false;
          this.tnxModal = true;
        }
      });
    },
    tnxModalHide() {
      this.tnxModal = false;
      if (this.$route.name == "lmsCourseView") {
        this.$router.push({
          name: "lmsCourseView",
          params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 },
        });
      } else {
        this.$emit("nav-dynamic-update", this.$route.params.id);
      }
    },
    getDuration(prms, mode) {
      return moment.duration(moment(prms.ed).diff(moment(prms.sd))).get(mode);
    },
    getExamDurationShow(form) {
      return !isNaN( moment
        .duration(moment(form.finishedAt).diff(moment(form.date)))
        .get("minutes"));
    },
    getExamDuration(form) {
      return moment
        .duration(moment(form.finishedAt).diff(moment(form.date)))
        .get("minutes");
    },
    submitExamQuestion(q, a, gId) {
      if (q.isFilled) {
        this.$bvToast.toast("Бөглөсөн байна!", {
          title: "Мэдэгдэл",
          autoHideDelay: 500,
          appendToast: false,
        });
        return false;
      }

      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker",
      });
      request({
        api: { method: "POST", url: "V2/Form/CheckExamQuestion" },
        params: {
          formId: this.id,
          questionId: this.mode == 0 ? q.id : q.qId,
          answerId: a != null ? (this.mode == 0 ? a.id : a.aId) : null,
          resultId: this.form.resultId,
          grpId: gId,
        },
        store: this.$store,
      }).then((res) => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker",
        });
        if (res != false) {
          if (q.t == 32 || q.t == 33 || q.t == 34) {
          } else if (q.t == 3) {
            if (gId == 1) {
              q.isFilled = true;
            }
            if (a != null) {
              a.isFilled = !a.isFilled;
            }
          } else {
            q.isFilled = true;
            q.answerId = a != null ? a.aId : null;
            if (a != null) {
              a.isFilled = true;
            }
          }
        }
      });
    },
    finishLessonExam(resultId) {
      this.$emit("on-toggle-class", {
        mode: "addClass",
        class: "dynamic-locker",
      });
      request({
        api: { method: "POST", url: "Form/ResultEnd" },
        data: { id: resultId },
        store: this.$store,
      }).then((res) => {
        this.$emit("on-toggle-class", {
          mode: "removeClass",
          class: "dynamic-locker",
        });
        if (res != false && res.data.result == 1) {
          this.lessonExamStarted(false);
          clearInterval(downloadTimer);
          this.$emit("on-update-result-count", this.id);
          this.showLessonExamResult();
          this.form.questions = [];
        }
      });
    },
    refillLessonExam(direct) {
      this.mode = 0;
      this.confirmObj.modal = true;
      if (direct != undefined && direct) {
        this.startLessonExam();
      }
    },
    rightSideBarChanged(e) {
      this.mydataaa = e;
    },
    getMainHeight() {
      let rv = "";
      let mh = 175;

      if (this.mode == 4) {
        mh = 55;
      }

      if (this.$store.state.app.isMobile && this.mode == 4) {
        mh = 55;
      } else if (this.$store.state.app.isMobile) {
        mh = 165;
      }
      rv = window.innerHeight - mh;
      if (this.fromModal) rv = rv - 90;
      this.scrollHeight = rv;
    },
    createMissingWordSelect(qId, gId, answers) {
      var ComponentClass = Vue.extend(wordselect);
      var instance = new ComponentClass({
        propsData: {
          gId: gId,
          qId: qId,
          answers: answers,
        },
        parent: this,
      });
      instance.$;
      instance.$mount();
      instance.$on("change", (e) => this.missingChanged(e));
      document.getElementById(`q_${qId}_${gId}`).appendChild(instance.$el);
    },
    generateMissingWords(q) {
      let rv = this.mode == 4 ? q.q : q.s1;
      for (let k = 1; k <= q.agc; k++) {
        let bldr = `<span id='q_${this.mode == 0 ? q.id : q.qId}_${k}'></span>`;
        rv = rv.replace("{" + k + "}", bldr);
      }
      return rv;
    },
    missingChanged(obj) {
      let _q = this.form.questions.filter(
        (x) => (this.mode == 0 ? x.id : x.qId) == obj.qId
      );
      if (_q.length) {
        _q = _q[0];
        let _a;
        if (this.mode == 0) {
          _a = _q.a.filter((x) => x.id == obj.aId);
        } else {
          _a = _q.as.filter((x) => x.aId == obj.aId);
        }

        if (_a.length) {
          _a = _a[0];
          this.submitExamQuestion(_q, _a, obj.gId);
        } else {
          this.submitExamQuestion(_q, null, obj.gId);
        }
      }
    },
    generateMissingWordsFilled(q) {
      let rv = q.q;
      for (let k = 1; k <= q.answerGroupCount; k++) {
        let at = q.as.filter((x) => x.g == k);
        let bldr = ``;
        if (at.length) {
          if (at.filter((x) => x["if"] == true && x["isTrue"] == true).length) {
            bldr = `<span class="badge badge-success">${
              at.filter((x) => x["isTrue"] == true)[0].a
            }</span>`;
          } else if (
            at.filter((x) => x["if"] == true && x["isTrue"] != true).length
          ) {
            bldr = `<span class="badge badge-danger">${
              at.filter((x) => x["if"] == true)[0].a
            }</span>`;
            bldr += ` ( <span class="badge badge-success">${
              at.filter((x) => x["isTrue"] == true)[0].a
            }</span> )`;
          } else if (at.filter((x) => x["isTrue"] == true).length) {
            bldr = `<span class="badge badge-warning">${
              at.filter((x) => x["isTrue"] == true)[0].a
            }</span>`;
          }
        }

        rv = rv.replace("{" + k + "}", bldr);
      }
      return rv;
    },
    sortedAnswers(q) {
      let rv = [];
      rv = _.orderBy(q.as, ["sec"], ["asc"]);
      return rv;
    },
  },
  computed: {
    showRightSideBar: {
      get: function() {
        return this.rightSideBar;
      },
      set: function() {},
    },
  },
};
</script>

<style lang="scss">
.qanchors-outer.invalid {
  border: 1px solid rgba(255, 0, 0, 0.2);
}
.qanchors-outer.invalid .qanchors {
  background: rgba(255, 0, 0, 0.03);
  color: red;
}
.qanchors:hover {
  background: rgba(0, 0, 0, 0.2);
}

.full-mdl {
  .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
    .modal-content {
      // background-color: #f5f6fa;
    }
  }
}
</style>
